import { createContext, useContext } from "react";

export const MissingRequirementsContext = createContext<readonly string[]>([]);

export function useMissingRequirement(id: string) {
  return useContext(MissingRequirementsContext).includes(id);
}
